<template>
  <a-modal
    :title="$t('CEMETARY')"
    :visible=isVisible
    @cancel="closeModal"
    class="cemetery-modal">
    <a-card class="cemetery-modal__body" v-if="currentCemetery !== {}">
      <div slot="cover" v-if="currentCemetery.place" class="cemetery-modal__carousel">
        <a-carousel arrows dots-class="slick-dots slick-thumb">
          <div
                  slot="prevArrow"
                  slot-scope="props"
                  class="custom-slick-arrow"
                  style="left: 10px;zIndex: 10000"
          >
            <a-icon type="left-circle" />
          </div>
          <div slot="nextArrow" slot-scope="props" class="custom-slick-arrow" style="right: 10px">
            <a-icon type="right-circle" />
          </div>
          <a slot="customPaging" slot-scope="props">
            <img :src="getImgUrl(props.i)" />
          </a>
          <div v-for="(photo, i) in currentCemetery.images">
            <img :src="'https://api.oooak.org/' + photo.url" />
            <a class="originalImage" target="_blank" :href="'https://api.oooak.org'+photo.url">{{ $t('ORIGINAL_IMAGE') }}</a>
          </div>
        </a-carousel>
      </div>
      <template class="ant-card-actions" slot="actions">
        <span>
          <ComplainModal :itemId=currentCemetery.id entityType="Cemetary"></ComplainModal>
        </span>
        <span v-if="currentCemetery.place.wiki">
          <a :href="currentCemetery.place.wiki" target="_blank">{{ $t('WIKIPEDIA') }}</a>
        </span>
        <span @click.stop="deleteLike(currentCemetery, user)">
          <a-icon type="heart" :theme="liked ? 'filled' : 'outlined'"/>
          {{ likesQuantity }}
        </span>
      </template>
      <div class="editButtonBlock" v-if="user && user.cemetaries && user.cemetaries.find(x => x.id === currentCemetery.id)">
        <a @click="openEditCemeteryPage(currentCemetery.id)">
          <a-icon twoToneColor="green" class="editButton" type="edit" theme="twoTone"/>
        </a>
      </div>
      <a-card-meta
        :title="currentCemetery.name ? currentCemetery.name : $t('UNKNOWN_CEMETERY_NAME')"
        :description="currentCemetery.place ? currentCemetery.place.description ? currentCemetery.place.description : $t('UNKNOWN_DESCRIPTION') : ''">
      </a-card-meta>
    </a-card>
    <MapModal></MapModal>
    <template slot="footer">
      <a-button
        @click="toggleMap(currentCemetery.place.latitude, currentCemetery.place.longitude)"
        type="primary"
        v-if="currentCemetery.place.latitude && currentCemetery.place.longitude">
        {{ $t('SHOW_ON_MAP') }}
      </a-button>
      <a-button
        type="primary"
        @click="goToMonument" >
        {{ $t('SHOW_MONUMENTS') }}
        <a-icon type="right"/>
      </a-button>
    </template>
  </a-modal>
  <!--cemetery.place.description-->
</template>

<script>
import BaseComponent from '../../extends/BaseComponent';
import ComplainModal from '../../common/complain-modal';
import MapModal from '../../common/map-modal';
import {mapActions, mapGetters, mapMutations} from 'vuex';
import {paramInURLToggle} from '../../../services/http';

export default {
  name: "cemeteries-modal",
  extends: BaseComponent,
  components: {ComplainModal, MapModal},
  computed: {
    ...mapGetters({
      isVisible: 'cemeteries/isShowModal',
      getCemeteriesById: 'cemeteries/getCemeteriesById',
      isAuth: 'user/isAuth',
      user: 'user/getUser',
      cemeteriesList: 'cemeteries/getCemeteriesList',
    }),
    currentCemetery: {
      get: function () {
        return this.$store.state.cemeteries.currentCemetery
      }
    },
    liked: {
      get: function () {
        if (this.currentCemetery.id) {
          if (this.cemeteriesList.find(x => x.id === this.currentCemetery.id)) {
            let cemeteryLikesArr = this.cemeteriesList.find(x => x.id === this.currentCemetery.id).likes
            if (cemeteryLikesArr.find(y => y.user_id === this.user.id)) {
              return true
            }
          } else {
            if (this.currentCemetery.likes.length) {
              if (this.currentCemetery.likes.find(y => y.user_id === this.user.id)) {
                return true
              }
            } else {
              return false
            }
          }
        }
      }
    },
    likesQuantity: {
      get: function () {
        if (this.currentCemetery.id) {
          if (this.cemeteriesList && this.cemeteriesList.find(x => x.id === this.currentCemetery.id)) {
            let cemetery = this.cemeteriesList.find(x => x.id === this.currentCemetery.id)
            let quantity = cemetery.likes.length
            return quantity
          } else {
            let dataFromCemetery = this.currentCemetery.likes.length
            return dataFromCemetery
          }
        }
      }
    }
  },
  data() {
    return {
      id: null,
      cemetery: {},
      visible1: false,
    }
  },
  watch: {
    '$route': {
      handler() {
        this.init()
      },
      immediate: true
    }
  },

  methods: {
    ...mapActions({
      getCemetery: 'cemeteries/getCemeteriesById',
      like: 'cemeteries/cemeteryLike',
      getCurrentCemetery: 'cemeteries/getCurrentCemetery',
      deleteCemeteryLike: 'cemeteries/deleteCemeteryLike',
      toggleComplain: 'toggleComplainModal',
      toggleMapModal: 'toggleMapModal',
      placeOfActivateEditPage: 'modal/placeOfActivateEditPage'
    }),
    ...mapMutations({
      setCementaryId: 'monuments/SET_CEMENTARY_ID',
    }),

    openEditCemeteryPage(id) {
      this.$store.commit('cemeteries/CEMETERIES_MODAL_TOGGLE');
      this.placeOfActivateEditPage('modal')
      this.$router.push('/en/cemetaries/edit/' + id)
    },

    toggleMap(latitude, longitude) {
      let data = []
      data.push(latitude, longitude)
      this.toggleMapModal(data)
    },

    async init() {
      if (this.$route.query.id) {
        await this.getCurrentCemetery(this.$route.query.id);
      }
    },

    closeModal() {
      paramInURLToggle('id', []);
      this.$store.state.app.complainModal = false;
      this.$store.commit('cemeteries/CEMETERIES_MODAL_TOGGLE');
      this.$store.state.cemeteries.currentCemetery = {place: {wiki: ''}}
    },

    getImgUrl(i) {
      if (this.currentCemetery.images) {
        return 'https://api.oooak.org/' + this.currentCemetery.images[i].url;
      }
    },

    deleteLike(item, user) {
      let cemeteryFromList = this.cemeteriesList.find(x => x.id == item.id)
      let userLike = cemeteryFromList.likes.find(x => x.user_id == user.id)
      if (userLike) {
        this.deleteCemeteryLike(userLike)
        this.init()
      } else {
        this.cemeteryLike(item.id)
        this.init()
      }
    },

    cemeteryLike(cemeteryId) {
      if (this.isAuth) {
        this.like({
          user_id: this.user.id,
          post_entity_id: cemeteryId,
          post_entity_type: "Cemetary"
        })
      } else {
        this.authModalToggle(this.$t('SIGN_IN_TO_LIKE'))
      }
    },

    goToMonument() {
      this.$store.commit('cemeteries/CEMETERIES_MODAL_TOGGLE');
      this.setCementaryId(this.currentCemetery.id)
      this.$router.push('/en/monuments?cemetary_id=' + this.currentCemetery.id);
    }
  },
  created() {
    this.init();
  },
}
</script>

<style lang="scss">
  .cemetery-modal {
    width: 600px !important;
    top: 10px;

    & > .ant-modal-content {
      & > .ant-modal-body {
        padding: 0;
      }

      img {
        width: 100%;
        max-height: 450px;
        object-fit: contain;
      }
    }

    .originalImage {
      display: flex;
      width: 100%;
      justify-content: center;
      color: rgba(0, 0, 0, 0.65);
    }

    .editButtonBlock {
      position: relative;
      display: flex;
      max-width: 100%;
      justify-content: end;

      a {
        text-align: end;
        position: absolute;
        width: 100%;

        i {
          font-size: 20px;
        }
      }

    }

    &__carousel {
      margin-bottom: 45px;
    }

    @media (max-width: 767px) {
      width: calc(100vw - 16px) !important;
    }
  }
</style>

<style scoped>

  .ant-carousel >>> .slick-track {
    display: flex;
    align-items: center;
  }

  .ant-carousel >>> .slick-dots {
    height: auto;
  }

  .ant-carousel >>> .slick-slide img {
    display: block;
    margin: auto;
  }

  .ant-carousel >>> .slick-thumb {
    bottom: -50px;
  }

  .ant-carousel >>> .slick-thumb li {
    width: 60px;
    height: 45px;
  }

  .ant-carousel >>> .slick-thumb li img {
    width: 100%;
    height: 100%;
    filter: grayscale(100%);
  }

  .ant-carousel >>> .slick-thumb li.slick-active img {
    filter: grayscale(0%);
  }

  .ant-carousel >>> .custom-slick-arrow {
    width: 25px;
    height: 25px;
    font-size: 25px;
    color: #DFDFDF;
    background-color: transparent;
    /*opacity: 0.9;*/
  }
  .ant-carousel >>> .custom-slick-arrow:before {
    display: none;
  }
  .ant-carousel >>> .custom-slick-arrow:hover {
    opacity: 0.5;
  }

  .ant-carousel >>> .slick-slide h3 {
    color: #fff;
  }
</style>
